<template>
  <div class="wind-template">
      <div class="card z-depth-0 custom-yellow grey-text text-darken-4">
        
        <div class="card-content" v-if="hasScore">
        <div class="step-title">
            Expected Impact Level
          </div>
          <div style="padding: 0 3px;">
          <p>
            Based on the results of your home assessment, the expected impact level to your home from Category 5 Hurricane-force winds has been estimated using the definitions and guidance provided in the <a href="#" helper-id="EXP100">Expected Impact Level Chart</a>. 
          </p>
          <p>
            Click the "confirm" option if you accept this estimation. If you disagree with the estimation, select a different expected impact level and include a brief justification for your selection based on additional knowledge of your home and past experiences.
          </p>
          </div>
        </div>

        <div class="card-content" v-else>
          <div class="step-title">
            Expected Impact Level
          </div>
          <div style="padding: 0 3px;">
            <p>
            Consider the results of your home assessment. Use the <a href="#" helper-id="EXP100">Expected Impact Level Chart </a> to select the expected impact level from Category 5 Hurricane-force winds.
            
            </p>
            <p style="margin-bottom:12px;" class="l"> 
Keep in mind that the characteristics of your home may not match exactly the guidance provided. Apply your best judgement using information from the assessment, additional knowledge of your home and past experiences to select the most likely expected impact level for your home. Write a brief justification for your selection in the space provided.
            </p>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
export default {
  name: 'windSurveyFinal',
  props:{
    hasScore:{
      type:Boolean,
      default: true,
    }
  },
  mounted (){
    this.$_setupHelpers()
  },
  methods:{
    $_openModal() {
      this.$emit('openModal', true)
    }, 
    $_setupHelpers() {
      const helpers = this.$el.querySelectorAll("[helper-id]");

      if (helpers) {
        helpers.forEach((helperEl) => {
          helperEl.addEventListener("click", (event) => {
            event.preventDefault()
            const helperId = helperEl.getAttribute("helper-id")
            const styles = helperEl.getAttribute("helper-style")
            this.$store.dispatch("Helpers/setHelper_", {id:helperId, styles:styles ? styles : ''})
           /*  this.$store.dispatch("Helpers/setHelper", helperId); */
          });
        });
      }
    },
  }
}
</script>
<style scoped lang="scss">
.custom-yellow {
  background: #fbd15e;
}
.step-title {
  font-size: 24px;
  i {    
    line-height: 32px;
    margin-right: 8px;
  }
}
</style>